<template>
  <table class="table table-bordered my-3">
    <thead class="thead">
      <tr>
        <th colspan="3">{{ $t('外注工程') }}</th>
        <th width="140">{{ $t('発注コード') }}</th>
        <th width="140">{{ $t('外注単価') }}</th>
        <th width="140">{{ $t('所要日数') }}</th>
        <th width="70"></th>
      </tr>
    </thead>
    <tbody class="tbody">
      <tr>
        <td rowspan="4" width="20">
          <button
            type="button"
            class="btn btn-light"
            :disabled="baseProcess.sort === 1 || baseProcess.sort === 2 && baseProcess.isMaterialPrepare"
            @click="changeSort('up')"
          ><font-awesome-icon :icon="['fas','arrow-up']"/></button><br>
          {{baseProcess.sort}}<br>
          <button
            type="button"
            class="btn btn-light"
            @click="changeSort('down')"
            :disabled="quantity === baseProcess.sort || baseProcess.isMaterialPrepare && baseProcess.sort === 1"
          ><font-awesome-icon :icon="['fas','arrow-down']"/></button>
        </td>
        <td rowspan="4" width="100">
          {{ $t(mixinProcessKindDisplay(baseProcess.processKindId)) }}<br v-if="baseProcess.processKindId">
          <button
            type="button"
            class="btn btn-light"
            @click="processKindsModalOpen()"
            :disabled="baseProcess.isMaterialPrepare && baseProcess.sort === 1"
          >{{ $t('工程区分選択') }}</button>
        </td>
        <td rowspan="2" width="100">
          <select-suggest-partner
          :additionalParams="{processKindId: baseProcess.processKindId}"
          :selectedId="baseProcess.partnerId"
          @selected="onSelectedPather"
        ></select-suggest-partner>
        </td>
        <td>
          <input :value="baseProcess.orderCode" @input="changeValue($event,'orderCode','string')" type="text" class="form-control">
        </td>
        <td>
          <div class="input-group">
            <input :value="baseProcess.purchasePrice" @input="changeValue($event,'purchasePrice','number')" type="number" min="0" class="form-control input">
            <div class="input-group-append">
              <span class="input-group-text">
                {{ $t('円') }}
              </span>
            </div>
          </div>
        </td>
        <td>
          <div class="input-group">
            <input :value="baseProcess.leadTime" @input="changeValue($event,'leadTime','number')" type="number" min="0" class="form-control input">
            <div class="input-group-append">
              <span class="input-group-text">
                {{ $t('日') }}
              </span>
            </div>
          </div>
        </td>
        <td rowspan="4">
          <button
            type="button"
            class="btn btn-light wf-50 mb-3"
            @click="copyProcess()"
          >{{ $t('複製') }}</button><br>
          <button
            type="button"
            class="btn btn-light wf-50 mb-3"
            @click="insertProcess()"
            :disabled="baseProcess.isMaterialPrepare && baseProcess.sort === 1"
          >{{ $t('挿入') }}</button><br>
          <button
            type="button"
            class="btn btn-danger wf-50"
            @click="deleteProcess()"
          >{{ $t('削除') }}</button>
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <input :value="baseProcess.note" @input="changeValue($event,'note','string')" type="text" class="form-control" :placeholder="$t('作業内容/申し送り事項')">
        </td>
      </tr>
      <tr>
        <td rowspan="2">
          <select-suggest-dest
            :selectedId="baseProcess.destId"
            :additionalParams="{partnerId: baseProcess.partnerId}"
            @selected="onSelectedDest"
          ></select-suggest-dest>
        </td>
        <th class="table-active" colspan="3">{{ $t('構成部品') }}</th>
      </tr>
      <tr>
        <td colspan="3" class="text-left">
          <base-process-structure
          v-for="(item, index) in baseProcess.structures" :key="`structure-${index}`"
          class="mb-2"
          :structure="item"
          :structures="structures"
          @addStructure="addStructure()"
          @removeStructure="removeStructure($event,index)"
          @changeStructure="changeStructure($event, index)"
          ref="baseStructure"
          ></base-process-structure>
          <button
            type="button"
            class="btn btn-light"
            @click="addStructure()"
          >{{ $t('追加') }}</button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex'
import baseProcessStructure from './baseProcessStructure'
import SelectSuggestPartner from '@/components/suggest/partner.vue'
import SelectSuggestDest from '@/components/suggest/dest.vue'

export default {
  props: {
    baseProcess: {
      type: Object,
      default: () => {},
    },
    processKinds: {
      type: Array,
      default: () => [],
    },
    quantity: {
      type: Number,
      default: 0,
    },
    structures: {
      type: Object,
      default: () => {},
    },
  },
  components: {baseProcessStructure, SelectSuggestDest, SelectSuggestPartner},
  async created() {
  },
  data() {
    return {
      partners: [],
      partnerSelected: {},
      dests: [],
      destSelected: {},
    }
  },
  methods: {
    onSelectedPather(newVal) {
      if (newVal !== null) {
        this.$emit('changeValue', { value: newVal.id, key: 'partnerId', type: 'number' })
      } else {
        this.$emit('changeValue', { value: null, key: 'partnerId', type: 'number' })
      }
      this.$emit('changeValue', { value: null, key: 'destId', type: 'number' })
    },
    onSelectedDest(newVal) {
      if (newVal !== null) {
        this.$emit('changeValue', { value: newVal.id, key: 'destId', type: 'number' })
      } else {
        this.$emit('changeValue', { value: null, key: 'destId', type: 'number' })
      }
    },
    // 工程区分のモーダルを表示
    processKindsModalOpen() {
      this.$emit('processKindsModalOpen')
    },
    // 標準工程をコピー
    copyProcess() {
      this.$emit('copyProcess')
    },
    // 標準工程を挿入
    insertProcess() {
      this.$emit('insertProcess')
    },
    // 標準工程を削除
    deleteProcess() {
      this.$emit('deleteProcess', this.baseProcess.sort)
    },
    // ソートを変更する処理
    changeSort(direction) {
      this.$emit('changeSort', { sort: this.baseProcess.sort, direction: direction })
    },
    // 値を変更する処理
    changeValue(e, key, type) {
      this.$emit('changeValue', { value: e.target.value, key: key, type: type })
    },
    // 構成部品の値を変更する処理
    changeStructure(e, index) {
      this.$emit('changeStructure', e, index, this.baseProcess.sort)
    },
    // 構成部品の値を変更する処理
    changeStructureValue(e, index) {
      this.$emit('changeStructureValue', {value: e.value, key: e.key, index: index, sort: this.baseProcess.sort})
    },
    // 構成部品を追加
    addStructure() {
      this.$emit('addStructure', { sort: this.baseProcess.sort })
    },
    // 構成部品を削除
    removeStructure(e, index) {
      this.$emit('removeStructure', { sort: this.baseProcess.sort, index: index })
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
  },
}
</script>

<style>
.IZ-select input[type="text"] {
  font-size: 1.4rem;
}

</style>
